import type { InternalAxiosRequestConfig } from "axios";

export const increaseGitApiTimeout = (config: InternalAxiosRequestConfig) => {
  if (config.url?.indexOf("/git/") !== -1) {
    if (config.url?.indexOf("/git/import/") !== -1) {
      config.timeout = 1000 * 600;
    } else {
      config.timeout = 1000 * 120;
    }
  }

  return config;
};
